import styled from '@emotion/styled';
import { Avatar } from '@mui/material';
import { FIELD_BACKGROUND, USER_AVATAR_COLOR } from '../../themes/tokens';

export const StyledUserAvatar = styled(Avatar)`
  width: 80px;
  height: 80px;
  font-size: 40px;
  color: ${USER_AVATAR_COLOR};
  background-color: ${FIELD_BACKGROUND};
`;
